import { ReactNode } from 'react';
import ReactDom from 'react-dom';

type Props = {
  children: ReactNode;
};

const Portal = ({ children }: Props) => {
  return ReactDom.createPortal(children, document.body);
};

export default Portal;
